export default __webpack_public_path__ + "static/media/Roboto-Thin.43cf5af8.woff";